import { Component, OnInit } from '@angular/core'
import { Actions } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Observable, of } from 'rxjs'
import { AppState } from 'src/app/core/core.state'
import { NotificationService } from 'src/app/core/notification.service'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'
import { Competition } from '../../competition'

import { filter, map, switchMap, take } from 'rxjs/operators'
import { competitionActions } from '../../competition.actions'
import { RequestQueryBuilder } from '@nestjsx/crud-request'
import { CompetitionPool } from '../../competition-pool/competition-pool'

import { competitionPoolActions } from '../../competition-pool/competition-pool.actions'
import { competitionPoolSelectors } from '../../competition-pool/competition-pool.selectors'
import { CompetitionLevel } from '../../competition-level/competition-level'
import { competitionLevelSelectors } from '../../competition-level/competition-level.selectors'
import { competitionLevelActions } from '../../competition-level/competition-level.actions'
import { ActivatedRoute } from '@angular/router'
import { BreadCrumbActions } from 'src/app/shared/components/breadcrumb/breadcrumb.actions'
import { AppRoutesNS } from 'src/app/app-routes.namespace'

@Component({
  selector: 'app-competition-details',
  templateUrl: './competition-details.component.html',
  styleUrls: ['./competition-details.component.scss']
})
export class CompetitionDetailsComponent implements OnInit {
  public selectedTab: string = 'matches'
  public competitionId$: Observable<number>
  public competition$: Observable<Competition>
  public competitionId: number
  public competitionPools$: Observable<CompetitionPool[]>
  public competitionLevels$: Observable<CompetitionLevel[]>
  public selectedPool: any
  public selectedLevel: any
  public selectedPool$!: Observable<any>
  public selectedLevel$: Observable<any>
  public isLoading$: Observable<boolean>
  public selectedCompetitionTeamIds: number[]
  public poolFilteredTeams: number[]
  public levelFilteredTeams: number[]
  public appRoutesNS = AppRoutesNS
  constructor(
    private store: Store<AppState>,
    public configurationService: ConfigurationService,
    private actions$: Actions,
    private notificationService: NotificationService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.store.dispatch(
      BreadCrumbActions.addPageToHistory({
        pageName: 'general.back',
        url: AppRoutesNS.Competitions.COMPETITIONS,
        showBackArrow: true,
        titleName: 'bookingModule.attendance'
      })
    )
    this.isLoading$ = this.store.select(
      competitionPoolSelectors.selectIsLoading
    )
    this.competitionId$ = this.route.paramMap.pipe(
      map((params) => params.get('competitionId')),
      map((id) => Number(id)),
      filter((id): id is number => !isNaN(id))
    )

    this.competitionId$.pipe(take(1)).subscribe((id) => {
      this.store.dispatch(
        competitionActions.fetchOneById({
          id,
          params: RequestQueryBuilder.create({
            join: [
              { field: 'competitionSport' }
              //TO DO: Add both fiels to normalizer
              // { field: 'competitionPools' },
              // { field: 'competitionLevels' }
            ]
          })
        })
      )
      const query = RequestQueryBuilder.create({
        search: { competitionId: id }
      })
      this.store.dispatch(competitionPoolActions.fetchMany({ params: query }))
      this.store.dispatch(competitionLevelActions.fetchMany({ params: query }))
    })

    this.competitionPools$ = this.competitionId$.pipe(
      filter((id) => id !== undefined && id !== null),
      switchMap((id) =>
        this.store.select(competitionPoolSelectors.selectByFilter, {
          field: 'competitionId',
          value: id
        })
      ),
      map((pools) =>
        pools.reduce((acc, pool) => {
          const existing = acc.find((item) => item.name === pool.name)
          if (!existing) {
            acc.push({ ...pool })
          }
          return acc
        }, [])
      )
    )

    this.competitionLevels$ = this.competitionId$.pipe(
      filter((id) => id !== undefined && id !== null),
      switchMap((id) =>
        this.store.select(competitionLevelSelectors.selectByFilter, {
          field: 'competitionId',
          value: id
        })
      ),
      map((levels) =>
        levels.reduce((acc, level) => {
          const existing = acc.find(
            (item: CompetitionLevel) => item.id === level.id
          )
          if (!existing) {
            acc.push({ ...level })
          }
          return acc
        }, [])
      )
    )
  }

  onSelect(value: string, type: 'pool' /*| 'level'*/) {
    if (!value) {
      if (type === 'pool') {
        this.selectedPool$ = of(null)
      }
      // if (type === 'level') {
      //   this.selectedLevel$ = of(null)
      // }

      return
    }
    if (type == 'pool') {
      value = value.split(': ')[1]
    }

    this.store
      .select(competitionPoolSelectors.selectByFilter, {
        // field: type == 'pool' ? 'name' : 'competitionLevelId',
        field: 'name',
        value: value
      })
      .pipe(take(1))
      .subscribe((pools: CompetitionPool[]) => {
        if (type === 'pool') {
          this.poolFilteredTeams = pools.map((pool) => pool.competitionTeamId)
        }
        // if (type === 'level') {
        //   this.levelFilteredTeams = pools.map((pool) => pool.competitionTeamId)
        // }

        this.updateFilteredTeams()
      })
  }

  updateFilteredTeams() {
    this.selectedCompetitionTeamIds = Array.from(
      new Set([
        ...(this.poolFilteredTeams ?? [])
        // ...(this.levelFilteredTeams ?? [])
      ])
    )
  }
}
